import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'
import Common from '../componentCaseHistory'
import React, { useEffect, useState } from 'react'
import FormLiquidation from './Forms'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { getCases, getFormLabel, getCasesImplicated, getFormLabelByForm} from '../../store/actions'
import { Auth, LoadingComponent } from 'recupero-comunes'
import { CasoGeneralComponent } from 'defensa-caso-general'

const RecordLiquidation = ({data, onGetGestionCases, onGetFormLabel, onGetGestionCasesImplicated, onGetFormLabelByForm, form}) => {
  const [loading] = useState(false)

  const { state } = useLocation()

  const { paisOrganizacion, rutUsuario } = Auth.currentUser()
  // ---Parametros
  const idOrgano = state?.row?.idOrgBien ? state.row.idOrgBien : '99017000'
  const idCaso = state?.row?.IdCaso ? state.row.IdCaso : 4
  const idImplicado = state?.row?.IdImplicado ? state.row.IdImplicado : 0
  const areaTrabajo = state?.formValues ? state.formValues : {}

  const user = rutUsuario

  useEffect(() => {
    onGetGestionCases({
      idOrgCaso: idOrgano,
      idCaso: idCaso
    })
    onGetFormLabel()
    onGetFormLabelByForm({
      rutcia: idOrgano,
      idform: 5
    })
    onGetGestionCasesImplicated({
      idOrgCaso: idOrgano,
      idCaso: idCaso
    })
  }, [])

  const options = {
    data: data?.cases[0],
    form: form,
    dataImplicated: data?.implicated,
    idCaso: idCaso,
    idImplicado,
    idOrgano
  }

  const optionsRecordLiquidation = {
    gestionCase: data?.cases[0],
    form: form?.formLabeByForm,
    idCaso,
    idOrgano,
    user,
    pais: paisOrganizacion,
    idImplicado,
    areaTrabajo
  }

  return (
    <Container className='mt-2'>
      <LoadingComponent show={loading || data.loading || form.loading} />

      {data?.cases.length > 0 &&
      Object.keys(form?.formLabel).length > 0 &&
      Object.keys(form?.formLabeByForm).length >= 0 ? (
        <Card className='mt-2'>
          {/*<Common {...options} />*/}
          <Card className='mt-2'>
            <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
              {form?.formLabeByForm['antecliquida-title-page']} {idCaso}
            </Card.Header>
            <Card.Body>
              <CasoGeneralComponent idCaso={idCaso} idImplicado={idImplicado} idOrganizacionCaso={idOrgano} /> 
            </Card.Body>                    
          </Card>
          <Card className='mt-2'>
            <Card.Body>              
                <FormLiquidation {...optionsRecordLiquidation} />
              </Card.Body>                    
            </Card>
        </Card>
      ) : null}
    </Container>
  )
}

const mapStateToProps = (state) => ({
  data: state.cases,
  form: state.formLabel
})

const mapDispatchToProps = (dispatch) => ({
  onGetGestionCases: (query) => dispatch(getCases(query)),
  onGetGestionCasesImplicated: (query) => dispatch(getCasesImplicated(query)),
  onGetFormLabel: () => dispatch(getFormLabel()),
  onGetFormLabelByForm: (query) => dispatch(getFormLabelByForm(query))
})

export default connect(mapStateToProps, mapDispatchToProps)(RecordLiquidation)
